import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu } from "antd";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import SkeltonList from "../../components/SkeltonEffect/list";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import moment from "moment";
import { list } from "../../controllers/orders/orders";

function OrderMainContent(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


OrderMainContent.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BasicTabs = ({orderList, isLoading}) => {  
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCurrentPage(1)
  };
  
  /********************** Integratin Stare Here **********************/
  const targetRef = useRef(null);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  
  const [showData, setShowData] = useState('shop');
  const [ALLLISTDATA, setAllListData] = useState([]);


  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      // setIsLoading(true);
      setAllListData([]);
      const options = {
        type: "",
        condition: {},
        select: {},
        sort: { status: 1, _id: -1 },
        skip: 0,
        limit: 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setAllListData(listData?.result);
        } else {
          setAllListData([]);
        }
      } else {
        setAllListData([]);
      }
      // setIsLoading(false);
    } catch (error) {
      // setIsLoading(false);
      console.log('error',error);
    }
  }; //End

  const navigate = useNavigate();
const handleEdit = async (item) => {
    navigate("/orders/addeditdata", { state: item });
  };

  const dropdownMenu = (items) => {
      return (
        <>
          <Menu>
            <Menu.Item key="0" onClick={() => handleEdit(items)}>
              <FaEdit />
              <span className="show_span_edit">View</span>
            </Menu.Item>
          </Menu>
        </>
      );
    };

  useEffect(()=>{
    getList();
  },[showData, isLoading])

  return (
    <>
      <div className="inventory_tabs_main_div mt-0" ref={targetRef}>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <div className="inventory_all_tabs">
              <div className="all_tabs_value_rating_review">
                {/* <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  className="item_tabs_main_container"
                >
                  <Tab
                    label="Shop"
                    className="tabs_main_contnet"
                    {...a11yProps(0)}
                    onClick={()=>handlechnage('shop')}
                  />
                  <Tab
                    label="Grooming"
                    className="tabs_main_contnet"
                    {...a11yProps(1)}
                    onClick={()=>handlechnage('grooming')}
                  />
                  <Tab
                    label="Veterinary"
                    className="tabs_main_contnet"
                    {...a11yProps(1)}
                    onClick={()=>handlechnage('veterinary')}
                  />
                  <Tab
                    label="Training"
                    className="tabs_main_contnet"
                    {...a11yProps(1)}
                    onClick={()=>handlechnage('training')}
                  />
                  <Tab
                    label="Day Care"
                    className="tabs_main_contnet"
                    {...a11yProps(1)}
                    onClick={()=>handlechnage('daycare')}
                  />
                </Tabs> */}
              </div>
            </div>
          </Box>
          {/* First Inventory */}
          <OrderMainContent
            className="main_container_payments"
          >
            <div>
              <div id="content-wrapper" className="d-flex flex-column">
                <div className="card mb-4">
                  <div className="card-header py-3 all_border_bottom_for_hide">
                    <h6 className="m-0 font-weight-bold common_inventory_heading">
                      Recent Orders
                    </h6>
                  </div>
                  <div className="card-body pt-0">
                    <div className="table-responsive">
                      <table
                        className="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Order No</th>
                            <th>Order total</th>
                            <th>Discount</th>
                            <th>Final Amount</th>
                            <th>Payment Status</th>
                            <th>Ordered On</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ALLLISTDATA?.length > 0 ? (
                            ALLLISTDATA.map((items, index) => (
                              <>
                                <tr key={index} onDoubleClick={() => handleEdit(items)}>
                                  <td>
                                    {items?.order_no}{" "}
                                  </td>
                                  <td className="admin_user_list_date">
                                    {" "}
                                    ${items?.order_total}{" "}
                                  </td>                              
                                  <td>
                                    ${items?.couponDiscount ? items?.couponDiscount : 0}{" "}
                                  </td>
                                  <td>
                                    ${items?.finalAmount}{" "}
                                  </td>
                                  <td>
                                    {items?.payment_status}{" "}
                                  </td>
                                  <td>
                                    {moment(items?.creation_date).format("DD MMMM YYYY hh:mm a")}{" "}
                                  </td>
                                  <td>
                                    <Dropdown
                                      overlay={() => dropdownMenu(items)}
                                      placement="bottomLeft"
                                      arrow
                                    >
                                      <HiOutlineDotsHorizontal />
                                    </Dropdown>
                                  </td>
                                </tr>
                              </>
                            ))
                          )  : <tr> 
                              <td colspan="5" className="img-center" ><img src='' width='55%'/></td> 
                          </tr>}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </OrderMainContent>
        </Box>
      </div>
    </>
  );
}

export default BasicTabs;
